import styled, { css } from 'styled-components';

export const InputDomainWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: 48px;
    width: 738px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
    }
  `};
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 8px 0px 0px 0px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const FirstRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin: 0px 0px 8px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0px 0px 24px;
    }
  `}
`;

const textWrapperPadding = 23;
export const TextFieldWrapper = styled.form`
  ${({ theme }) => css`
    display: flex;
    padding: 0px ${textWrapperPadding}px 0px;
    position: relative;

    > div > div {
      padding-left: 67px;
      position: relative;

      &:before {
        color: ${theme.v2.colors.neutral.lowMedium};
        content:'www.';
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        left: 16px;
        line-height: ${theme.v2.font.lineHeight.text};
        position: absolute;
        top: 20px;
      }
    }

    label {
      font-size: ${theme.v2.font.sizes.xs};
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px;
    }
  `}
`;

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    margin: 32px 0px 0px;
    padding: 16px;
    div {
      align-items: start;
    }

    > div:first-child {
      padding: 0px;

      svg {
        background-color: ${theme.v2.colors.neutral.highPure};
        border-radius: 100%;
        padding: 3px;
      }

      a {
        color: ${theme.v2.colors.brand.primaryBlue};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        text-decoration-color: ${theme.v2.colors.brand.primaryBlue} !important;
      }

      span {
        color: ${theme.v2.colors.brand.primaryBlue};
        text-decoration: underline;
      }
      @media (max-width: ${theme.v2.breakpoints.md}) {
        p {
          font-size: ${theme.v2.font.sizes.xxxs};
        }
        a {
          font-size: ${theme.v2.font.sizes.xxxs};
        }
      }
    }
  `}
`;

export const ActionsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column-reverse;
      margin-bottom: 120px;
    }
  `}
`;
